$(document).ready(function () {
  //获取来源
  var workNumber = sessionStorage.getItem("workNumber");
  //机场需要携带工号，不展示直接购买按钮
  if($('.shopify-payment-button').length > 0 && workNumber) {
    $('.shopify-payment-button').hide();
  }

  //获取商品数据
  const path = window.location.pathname;
  const productHandle = path.split("/").filter(Boolean).pop(); //获取产品handle
  let productData = {},
    isCtripProduct = false;
  $.ajax({
    type: "get",
    url: `/products/${productHandle}.json`,
    dataType: "json",
    data: {},
    success: function (res) {
      productData = res.product;
      isCtripProduct = productData.product_type == "Trip" ? true : false; //是否携程商品
      if(!isCtripProduct && workNumber) {
        $('#product-customer-btn').attr('data-action', 'airport');
      }
    },
    error: function () {
      console.error("获取产品信息时出错:", error);
    },
  });
  

  //获取商品sectionId
  var sectionId = document
    .getElementById("custom-modal")
    .getAttribute("data-section-id");
    

  //获取产品的variantId
  let variantId = $("#product-variant-id").val();
  const elements = document.querySelectorAll(`[id*=${sectionId}]`); // 选择所有 ID 包含 sectionId 的元素，为了从url中分获取variantId
  elements.forEach((element) => {
    element.addEventListener("change", () => {
      variantId = getUrlValue("variant");
    });
  });
  console.log(variantId);
  
  $('#product-customer-btn').click(function(e) {
    const productBtnAction = $('#product-customer-btn').data('action');
    console.log(productBtnAction);
    switch (productBtnAction) {
      case 'default':
        console.log("default");
        break;
      case 'Trip':
        e.preventDefault();
        tripAction();
        break;
      case "airport":
        e.preventDefault();
        airportAction();
        break;
    }
  })

  // 机场添加购物车
  function airportAction() {
    console.log("机场添加购物车");
    let quantity = $(`#Quantity-${sectionId}`).val();
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        id: variantId ? variantId : $("#product-variant-id").val(), // 商品的变体ID
        quantity,
        properties: { workNumber: workNumber },
      },
      success: function () {
        window.location.href = "/cart";
      },
      error: function (err) {
        console.log(err);
        alert("add to cart error！");
      },
    });
  }

  //自定义参数 用户手机号
  const mobileCreateFromItem = {
    questionID: "ybb_mobile",
    code: "YBBMOBILE",
    type: "BASIC",
    allPassagerRequired: true,
    title: "Contact Number",
    selectType: "SINGLE",
    dataType: "TEXT",
  };

  // 完善信息
  let passengerQuestionList = [];
  let ctripCountryCode = {};
  function tripAction() {
    let quantity = $(`#Quantity-${sectionId}`).val();
    passengerQuestionList = [];

    //获取携程的额外信息
    $.ajax({
      type: "GET",
      url: "https://www.youbanban.com/strawberry/ctrip/distribution/question/query",
      dataType: "json",
      data: {
        variantId,
      },
      success: function (res) {
        if (res.error == null) {
          $("#custom-modal").css("display", "block");
          const $form = $("#product-extra-form");
          $form.empty();
          
          if (res.data) {
            //证件只填写护照
            passengerQuestionList = res.data.passengerQuestionList.filter(ele => ele.type != "CREDENTIALS" || (ele.type == "CREDENTIALS" && ele.code == "P_PASSPORT"));
            let index = passengerQuestionList.findIndex(
              (ele) => ele.code == "P_TELPHONE_AREA_CODE"
            );
            if (index != -1) {
              ctripCountryCode = passengerQuestionList.splice(index, 1)[0];
            }
            passengerQuestionList.forEach((ele) => {
              //性别
              if (ele.code == "P_GENDER") {
                ele.dataType = "ENUM";
                ele.questionItemList = [
                  { title: "Male", itemID: "M" },
                  { title: "Female", itemID: "F" },
                ];
              } else if (ele.code == "P_TELPHONE") {
                ele.title = "User's Phone Number";
              }
            });
          }
          if (isCtripProduct) {
            passengerQuestionList.push(mobileCreateFromItem);
          }

          // 遍历生成表单
          $.each(passengerQuestionList, function (index, question) {
            let $formGroup = $("<div>").addClass("form-group");
            // let $formTitle = $("<div>").text("出行人1").addClass("form-group-title");
            // $formGroup.append($formTitle);
            let $label = $("<label>")
              .text(question.title)
              .attr("for", question.code);
            $formGroup.append($label);

            if (question.code === "YBBMOBILE") {
              let $inputContainer = $("<div>").addClass("input-container");

              // 创建国家区号输入框
              let $countryCodeInput = $("<input>").attr({
                type: "text",
                name: "countryCode",
                id: "countryCode",
                placeholder: "Country Code",
                style: "width: 30%;", // 设置宽度
              });

              // 创建中间的 "-" 符号
              let $separator = $("<span>").text(" - ").css({
                "align-self": "center", // 使 "-" 水平居中
                "font-size": "16px",
              });

              // 创建手机号输入框
              let $mobileInput = $("<input>").attr({
                type: "text",
                name: question.code,
                id: question.code,
                placeholder: "Mobile Number",
                style: "width: 65%;", // 设置宽度
              });

              // 将国家区号输入框、"-" 符号、手机号输入框添加到input容器
              $inputContainer
                .append($countryCodeInput)
                .append($separator)
                .append($mobileInput);

              // 添加input容器到表单组
              $formGroup.append($inputContainer);
            } else if (question.code === "P_TELPHONE") {
              let $inputContainer = $("<div>").addClass("input-container");

              // 创建国家区号输入框
              let $countryCodeInput = $("<input>").attr({
                type: "text",
                name: "P_TELPHONE_AREA_CODE",
                id: "P_TELPHONE_AREA_CODE",
                placeholder: "Country Code",
                style: "width: 30%;", // 设置宽度
              });

              // 创建中间的 "-" 符号
              let $separator = $("<span>").text(" - ").css({
                "align-self": "center", // 使 "-" 水平居中
                "font-size": "16px",
              });

              // 创建手机号输入框
              let $mobileInput = $("<input>").attr({
                type: "text",
                name: question.code,
                id: question.code,
                placeholder: "Mobile Number",
                style: "width: 65%;", // 设置宽度
              });

              // 将国家区号输入框、"-" 符号、手机号输入框添加到input容器
              $inputContainer
                .append($countryCodeInput)
                .append($separator)
                .append($mobileInput);

              // 添加input容器到表单组
              $formGroup.append($inputContainer);
            } else if (question.selectType === "SINGLE") {
              if (
                question.dataType === "TEXT" ||
                question.dataType === "NUMBER"
              ) {
                let inputType =
                  question.dataType === "NUMBER" ? "number" : "text";
                let $input = $("<input>").attr({
                  type: inputType,
                  name: question.code,
                  id: question.code,
                });
                $formGroup.append($input);
              } else if (
                question.dataType === "DATE" ||
                question.dataType === "DATETIME"
              ) {
                let inputType =
                  question.dataType === "DATETIME" ? "datetime-local" : "date";
                let $input = $("<input>").attr({
                  type: inputType,
                  name: question.code,
                  id: question.code,
                });
                $formGroup.append($input);
              } else if (
                question.dataType === "BOOLEAN" &&
                question.questionItemList
              ) {
                // 为 BOOLEAN 类型生成单选框
                $.each(question.questionItemList, function (idx, item) {
                  let $radio = $("<input>").attr({
                    type: "radio",
                    name: question.code,
                    id: question.code + "_" + idx,
                    value: item,
                  });
                  let $radioLabel = $("<label>")
                    .addClass("radio-label")
                    .attr("for", question.code + "_" + idx)
                    .text(item);
                  $formGroup.append($radio).append($radioLabel);
                });
              } else if (
                question.dataType === "ENUM" &&
                question.questionItemList
              ) {
                let $select = $("<select>").attr({
                  name: question.code,
                  id: question.code,
                });
                $.each(question.questionItemList, function (idx, item) {
                  let $option = $("<option>").val(item.itemID).text(item.title);
                  $select.append($option);
                });
                $formGroup.append($select);
              }
            } else if (
              question.selectType === "MULTIPLE" &&
              question.dataType === "ENUM"
            ) {
              // 为 MULTIPLE 类型生成复选框
              $.each(question.questionItemList, function (idx, item) {
                let $checkbox = $("<input>").attr({
                  type: "checkbox",
                  name: question.code,
                  id: question.code + "_" + idx,
                  value: item,
                });
                let $checkboxLabel = $("<label>")
                  .addClass("checkbox-label")
                  .attr("for", question.code + "_" + idx)
                  .text(item);
                $formGroup.append($checkbox).append($checkboxLabel);
              });
            }

            $form.append($formGroup);
          });
        }
      },
      error: function () {
        alert("Failed to retrieve information！");
      },
    });
  }

  // 监听 "添加到购物车" 按钮点击事件
  $("#addToCart").click(function () {
    let properties = {};
    let isFormValid = true; // 验证表单

    //验证表单并生成
    $("#product-extra-form")
      .find("input, select")
      .each(function () {
        let name = $(this).attr("name");
        let value = $(this).val();

        // 检测国家区号和手机号
        if (name === "countryCode" || name === "YBBMOBILE") {
          let countryCode = $("input[name='countryCode']").val();
          let mobileNumber = $("input[name='YBBMOBILE']").val();

          // 如果国家区号或手机号是必填项并且有一个为空
          if (!countryCode || !mobileNumber) {
            isFormValid = false;
            alert("Country code and mobile number are required！");
            $("input[name='countryCode']")
              .siblings("label")
              .addClass("label-error");
            $("input[name='YBBMOBILE']")
              .siblings("label")
              .addClass("label-error");
            return false;
          } else {
            $("input[name='countryCode']")
              .siblings("label")
              .removeClass("label-error");
            $("input[name='YBBMOBILE']")
              .siblings("label")
              .removeClass("label-error");
          }
        }
        if (name === "userCountryCode" || name === "userPhoneNumber") {
          let userCountryCode = $("input[name='userCountryCode']").val();
          let userPhoneNumber = $("input[name='userPhoneNumber']").val();

          // 如果国家区号或手机号是必填项并且有一个为空
          if (!userCountryCode || !userPhoneNumber) {
            isFormValid = false;
            alert("Country code and mobile number are required！");
            $("input[name='userCountryCode']")
              .siblings("label")
              .addClass("label-error");
            $("input[name='userPhoneNumber']")
              .siblings("label")
              .addClass("label-error");
            return false;
          } else {
            $("input[name='userCountryCode']")
              .siblings("label")
              .removeClass("label-error");
            $("input[name='userPhoneNumber']")
              .siblings("label")
              .removeClass("label-error");
          }
        }

        let isRequired = passengerQuestionList.some(
          (question) => question.code === name && question.allPassagerRequired
        );
        // 检查必填项是否为空
        if (isRequired && (!value || value.length === 0)) {
          isFormValid = false; // 设置表单无效
          $(this).siblings("label").addClass("label-error");
          let index = passengerQuestionList.findIndex(
            (ele) => ele.code == name
          );
          alert(`${passengerQuestionList[index].title} is required！`);
          return false;
        } else {
          $(this).siblings("label").removeClass("label-error");
        }

        // 如果是单选按钮，确保只选中一个值
        if ($(this).is(":radio")) {
          if ($(this).is(":checked")) {
            properties[name] = [value];
          }
        } else if ($(this).is(":checkbox")) {
          // 处理复选框，确保选中项被正确添加为数组
          if (!properties[name]) {
            properties[name] = [];
          }
          if ($(this).is(":checked")) {
            properties[name].push(value);
          }
        } else {
          if (name == "YBBMOBILE" || name == "countryCode") {
            properties[name] = value;
          } else {
            properties[name] = [value];
          }
        }
      });
    if (isFormValid) {
      let params = {};
      let questionAnswerList = [];
      let passengerQuestionListCopy = JSON.parse(
        JSON.stringify(passengerQuestionList)
      );
      if (properties.P_TELPHONE_AREA_CODE) {
        passengerQuestionListCopy.push(ctripCountryCode);
      }
      Object.entries(properties).forEach(([key, value]) => {
        passengerQuestionListCopy.forEach((ele) => {
          if (key === "YBBMOBILE" && value != "") {
            params.mobile = `${properties.countryCode}-${value}`;
          } else if (key === ele.code && key != "YBBMOBILE") {
            questionAnswerList.push({
              questionID: ele.questionID,
              questionCode: ele.code,
              questionTitle:
                ele.code == "P_TELPHONE" ? "Contact Number" : ele.title,
              answerList: value,
            });
          }
        });
      });
      if (workNumber) {
        params.workNumber = workNumber;
      }
      params.questionAnswerList = JSON.stringify(questionAnswerList);

      // 向 Shopify 购物车添加商品及表单自定义数据
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          id: variantId ? variantId : $("#product-variant-id").val(), // 商品的变体ID
          quantity: 1,
          properties: params,
        },
        success: function () {
          window.location.href = "/cart";
        },
        error: function () {
          alert("add to cart error！");
        },
      });
    }
  });

  // 关闭弹窗
  $("#modal-content-close").click(function () {
    $("#custom-modal").css("display", "none");
  });

  // 定义函数用于获取 URL 中的 variant 参数
  function getUrlValue(key) {
    const urlParams = new URLSearchParams(window.location.search);
    const value = urlParams.get(key); // 获取 URL 中的 key 参数
    return value;
  }
});
